import { z } from 'zod';

import { AI_MODEL_TYPE_OPTIONS } from '../constants';

export const zodValidateLabelingPositionConsistencySchema = z.object({
  modelChoice: z.enum(AI_MODEL_TYPE_OPTIONS).optional().prefault('di'),
  percentile: z
    .enum(['high', 'medium', 'low', 'auto'])
    .optional()
    .prefault('auto'),
  projectName: z.string().min(1),
});
